import { ref, type Ref } from 'vue';
import { orderBy, findIndex } from 'lodash-es';

interface SortCol {
  colName: string;
  sort: number;
}

function getSortParams(sortCols: SortCol[]) {
  const result: {
    fields: string[];
    orders: ('asc' | 'desc')[];
  } = { fields: [], orders: [] };

  for (const { colName, sort } of sortCols) {
    result.fields.push(`data.${colName}`);

    if (sort === 1) {
      result.orders.push('asc');
    } else if (sort === -1) {
      result.orders.push('desc');
    }
  }
  return result;
}

export class TableSorter {
  sortColumns: Ref<SortCol[]>;

  constructor() {
    this.sortColumns = ref([]);
  }

  sortItems(items: any[]): any[] {
    const { fields, orders } = getSortParams(this.sortColumns.value);
    if (fields.length === 0) {
      return items;
    }
    return orderBy(items, fields, orders);
  }

  updateSortColumn(
    colName: string,
    sort: number | undefined,
    multiSort = false,
  ) {
    const existingIndex = findIndex(this.sortColumns.value, { colName });

    if (sort === 0) {
      if (existingIndex > -1) {
        this.sortColumns.value.splice(existingIndex, 1);
      }
      return;
    }

    if (multiSort) {
      if (existingIndex > -1) {
        this.sortColumns.value[existingIndex].sort = sort!;
      } else {
        this.sortColumns.value = [
          ...this.sortColumns.value,
          { colName, sort: sort! },
        ];
      }
    } else {
      this.sortColumns.value = [{ colName, sort: sort! }];
    }
  }
}

export function toggleSort(sort: number): number | undefined {
  if (sort === 0) {
    return 1;
  }
  if (sort === 1) {
    return -1;
  }
  if (sort === -1) {
    return 0;
  }
  return 0;
}
